module.exports = __webpack_public_path__ + "static/media/verde.8f94ba78.svg";